export default {
  items: [],
  unreadCount: 0,
  isLoading: false,
};
